import fetch, { parseResponse, parseFileResponse } from "./fetch";

export interface ExportInterface {
    id: string;
    file_id: string;
    total_rows: number;
    written_rows: number;
    memory_used: number;
    time_used: string;
    data: ExportDataInterface;
    updated_at: string;
    created_at: string;
    canceled_at: string;
    finished_at: string;
    file?: FileInterface;
    status: 'COMPLETED' | 'PROCESSING' | 'PENDING' | 'CANCELED';
}

export interface ExportDataInterface {
    id: string;
    filter_name?: string;
    groups: string[];
    filename: string;
    updated_at: string;
    created_at: string;
}

class Export {
    one(id: string) {
        return parseResponse<ExportInterface>(fetch.get(`export/${id}`));
    }

    export(params?: HashMap<any>) {
        return parseResponse<ExportInterface>(fetch.post(`export/`, params));
    }

    download(id: string) {
        return parseFileResponse(fetch.get(`file/${id}`));
    }

    getExportFile() {
        return parseFileResponse(fetch.get(`export/file`));
    }

    getSelectedFileFromGroup(params?: HashMap<any>) {
        return parseFileResponse(fetch.post('export/fromGroup', params));
    }

    getSelectedArchiveFromDiagram(params?: HashMap<any>) {
        return parseFileResponse(fetch.post('export/fromDiagram', params));
    }
}


export default new Export();
